export default __webpack_public_path__ + "static/media/cat10.ec0f43a4.png";